import axios from "axios";
import { BASE_URL_API } from "constants/base-url-api";

import { OtherGuestsForm } from "containers/ListingDetailPage/listing-stay-detail/ReservationForm";
import { getCookie } from "utils/functions-cookie";

export type DataProp = {
  hotel_id: number;
  room_id: number;
  points: number;
  token: string;
  guests: (
    | OtherGuestsForm
    | {
        name: string;
        cpf: string;
        age: string | number;
        phone: string;
        email: string;
        main_pax: boolean;
      }
  )[];
}

export const fetchBooking = async (data: DataProp) => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }

  const base = axios.create({
    baseURL: BASE_URL_API,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${authToken}`,
    },
  });

  const response = await base.post(`/bookings`, data);

  if (response.status !== 201) {
    throw new Error("Erro ao criar reserva");
  }

  return response.data;
};
